import { ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes } from "react-router-dom";
import "./App.scss";
import Navigation from "./navigation";
import ForgetScreen from "./screens/forgetPassword";
import ChangePassword from "./screens/forgetPassword/changepassword";
import LoginScreen from "./screens/loginScreen";
import HomeScreen from "./screens/homeScreen";
import ContactScreen from "./screens/contact";
import PriceScreen from "./screens/price";
import SupportScreen from "./screens/support";
import HelpScreen from "./screens/help";
import SignUpScreen from "./screens/signupScreen";
import ProtectedRoute from "./utils/protectedRoute";
import "./language/index";

function App() {
  const User = useSelector((state: any) => state.User);

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "#36b372",
            fontFamily: "Medium",
          },
        }}
      >
        <Routes>
          {/* Public Routes with Website Header */}
          <Route path="/" element={<LoginScreen />} />
         
          
          {/* Authentication Routes */}
          <Route
            path="/login"
            element={
              User?.auth ? (
                <Navigate to="/auth/dashboard" replace />
              ) : (
                <LoginScreen />
              )
            }
          />
         
          
          
          {/* Protected Dashboard Routes */}
          <Route
            path="/auth/*"
            element={
              <ProtectedRoute isSignedIn={User?.auth}>
                <Navigation />
              </ProtectedRoute>
            }
          />
          
          {/* Fallback route */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ConfigProvider>
    </>
  );
}

export default App;
